var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "v-dialog",
        {
          attrs: {
            persistent: "",
            transition: "dialog-bottom-transition",
            width: "600"
          },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-form",
                {
                  ref: "form",
                  attrs: { "lazy-validation": "" },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c(
                    "v-card-title",
                    { staticClass: "headline" },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs9: "" } },
                        [
                          _c("v-icon", [_vm._v("mail")]),
                          _vm._v(" NOTIFICACIÓN ")
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          nativeOn: {
                            click: function($event) {
                              return _vm.closeDialog()
                            }
                          }
                        },
                        [_c("v-icon", [_vm._v("close")])],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "px-3" },
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "text-xs-center",
                              attrs: { xs12: "" }
                            },
                            [
                              _c("h4", { staticClass: "blue--text" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.falta.nombres) +
                                    "\n              "
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "layout justify-center pb-4",
                              attrs: { xs12: "" }
                            },
                            [
                              _c(
                                "table",
                                {
                                  staticClass: "tabla-faltas",
                                  attrs: { id: "tabla-faltas" }
                                },
                                [
                                  _c("tr", [
                                    _c("th", [_vm._v("Fecha")]),
                                    _vm._v(" "),
                                    _c("th", [_vm._v("Descripción")]),
                                    _vm._v(" "),
                                    _c("th", [_vm._v("Horario")]),
                                    _vm._v(" "),
                                    _c("th", [_vm._v("Hora marcada")]),
                                    _vm._v(" "),
                                    _c("th", [_vm._v("Falta")])
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.falta.control_asistencia, function(
                                    marcado
                                  ) {
                                    return _c(
                                      "tr",
                                      { key: marcado.id_persona },
                                      [
                                        _c(
                                          "td",
                                          { staticStyle: { width: "25%" } },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  _vm
                                                    .$moment(
                                                      marcado.fecha_marcado
                                                    )
                                                    .format("DD/MM/YYYY")
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticStyle: { width: "25%" } },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  marcado.descripcion
                                                    ? marcado.descripcion
                                                    : "-"
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticStyle: { width: "25%" } },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  marcado.horario
                                                    ? marcado.horario
                                                    : "-"
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticStyle: { width: "25%" } },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  marcado.hora_marcada
                                                    ? marcado.hora_marcada
                                                    : "-"
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          { staticStyle: { width: "25%" } },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  marcado.detalle_marcado
                                                ) +
                                                "\n                  "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  })
                                ],
                                2
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "p-0 m-0",
                                  attrs: {
                                    color: "#0085AD",
                                    loading: _vm.loading,
                                    dark: "",
                                    block: "",
                                    title: "Notificar faltas"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.notificarCorreo(_vm.falta)
                                    }
                                  }
                                },
                                [
                                  _c("v-icon", [_vm._v("mail")]),
                                  _vm._v(
                                    "\n                ENVIAR CORREO\n              "
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-card-actions")
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3e192ee0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3e192ee0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/asistencia/components/EnviaCorreoIndividual.vue
// module id = null
// module chunks = 